import React, { useState } from "react";

import { TextInput } from "@/shared/components/settings-atoms";
import { LIMIT_RULES } from "./editing";
import { useSavedText } from "./useSavedText";

/* One limit — a daily budget or messages per ten minutes — saved when the field is left.
   Empty is null: the fallback the hint names. A value out of range says so under the field
   and isn't sent. */
export function LimitRow({ field, label, hint, placeholder, value, onSave }: {
  field: keyof typeof LIMIT_RULES;
  label: string;
  hint: string;
  placeholder: string;
  value: number | null;
  onSave: (value: number | null) => void;
}) {
  const rule = LIMIT_RULES[field];
  const [issue, setIssue] = useState(false);
  const text = useSavedText(value === null ? "" : String(value), (typed) => {
    const number = Number(typed);
    const ok = !typed.trim() || rule.valid(number);
    setIssue(!ok);
    if (ok) onSave(typed.trim() ? rule.rounded(number) : null);
  });
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2.5 py-3.5">
      <div className="flex-1 min-w-0 basis-[170px]">
        <div className="text-[13.5px] font-medium text-[var(--text-primary)]">{label}</div>
        <div className={`mt-0.5 text-[12.5px] leading-[1.5] ${issue ? "text-[var(--danger)]" : "text-[var(--text-tertiary)]"}`}>
          {issue ? rule.issue : hint}
        </div>
      </div>
      <TextInput
        aria-label={label}
        aria-invalid={issue}
        inputMode={field === "daily_budget_usd" ? "decimal" : "numeric"}
        placeholder={placeholder}
        value={text.value}
        onChange={text.set}
        onBlur={text.onBlur}
        onKeyDown={text.onKeyDown}
        className={`w-[112px] font-mono tabular-nums ${issue ? "ring-[var(--danger-ring)]" : ""}`}
      />
    </div>
  );
}
